<template>
  <v-app>
    <!-- session start-->
    <v-dialog v-model="dialogtimeout" persistent width="420">
      <v-card>
        <v-card-title class="headline">Session Expired</v-card-title>
        <div style="padding-left: 20px">
          You have left this browser for 5 minutes. Please Login again.
        </div>
        <v-card-actions>
          <br /><br /><br />
          <v-spacer></v-spacer>
          <center>
            <v-btn style="color: white" color="green" text @click="logout">OK</v-btn>
          </center>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- session end-->
    <!-- desktop navi-->
    <v-navigation-drawer permanent width="310" v-model="drawer" :mini-variant.sync="mini" app v-if="!mobileView"
      style="background-color: #0c3960 !important">
      <v-toolbar flat class="transparent">
        <v-list class="pa-0" style="background-color: #0c3960 !important">
          <v-list-tile avatar>
            <!-- <v-avatar class="inetlogo" tile color="white" style="width: 101.8px; height: 56px; margin-right:10px;">
              <img :src="images.logo" />
            </v-avatar> -->
            <v-avatar style="margin-right: 45px; height: 60px" @click.stop="mini = !mini">
              <img :src="images.logo" class="logo" /></v-avatar>
            <v-list-tile-content>
              <v-list-tile-title style="color: white">Internet Thailand</v-list-tile-title>
              <v-list-tile-sub-title style="font-size: 12px; color: white">Public Company
                Limited</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>


      <!-- tab for user and admin -->
      <!-- Admin -->
      <v-list class="pt-4" style="padding: 0px; background-color: #0c3960;">

        <!-- สร้างรายการ -->
        <v-list-tile v-for="item in mainitems" :key="item.title" :to="item.path" active-class="sidemenu"
          v-if="role == 'admin' || role == 'user'">
          <v-list-tile-action>
            <v-icon style=" color: white;">{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title style="font-size: 17px; color: white">{{
              item.title
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- ประวัติการทำรายการแอดมิท -->
        <v-list-tile v-for="item in Adminitems" :key="item.title" :to="item.path" active-class="sidemenu"
          v-if="role == 'admin'">
          <v-list-tile-action>
            <v-icon style=" color: white;">{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title style="font-size: 17px;  color: white">{{
              item.title
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Acconut Management -->
        <v-list-group v-if="role == 'admin'" no-action value="true" v-model="drawerAcconut">
          <template v-slot:activator>
            <v-list-tile-action>
              <v-icon style="padding: 0 0 0 16px; color: white">mdi-account-multiple</v-icon>
            </v-list-tile-action>
            <v-list-tile style="padding: 0px;">
              <v-list-tile-title style="font-size: 17px;  color: white">การจัดการบัญชีผู้ใช้งาน</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="item in management" :key="item.title" :to="item.path" active-class="sidemenu"
            style="margin-left: -30px;">
            <v-list-tile-action>
              <v-icon style="font-size: 18px;  color: white">
                {{ item.icon }}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 16.5px;  color: white">{{
                item.title
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <!-- End Admin -->

        <!-- User -->
        <!-- ประวัติการทำรายการ -->
        <v-list-tile v-for="item in Useritems" :key="item.title" :to="item.path" active-class="sidemenu"
          v-if="role == 'user'">
          <v-list-tile-action>
            <v-icon style="color: white;">{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-ti style="font-size: 18px;  color: white">{{
              item.title
            }}</v-list-tile-ti>
          </v-list-tile-content>
        </v-list-tile>
        <!-- End User -->
      </v-list>
    </v-navigation-drawer>
    <!-- end desktop-->

    <!-- mobile desktop-->
    <v-navigation-drawer v-if="mobileView" width="290" v-model="drawer" absolute app
      style="background-color: #0c3960 !important">
      <v-toolbar flat class="transparent">
        <v-list class="pa-0" style="background-color: #0c3960 !important">
          <v-list-tile avatar>
            <v-avatar style="margin-right: 40px">
              <img :src="images.logo" class="logo" /></v-avatar>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 1rem; color: white">Internet Thailand</v-list-tile-title>
              <v-list-tile-sub-title style="font-size: 0.8rem; color: white">Public Company
                Limited</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <!-- tab mobile for user and admin -->
      <!-- Admin -->
      <v-list class="pt-4" style="padding: 0px; background-color: #0c3960;">
        <!-- สร้างรายการ -->
        <v-list-tile v-for="item in mainitems" :key="item.title" :to="item.path" active-class="sidemenu"
          v-if="role == 'admin' || role == 'user'">
          <v-list-tile-action>
            <v-icon style=" color: white;">{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title style="font-size: 15px;  color: white">{{
              item.title
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- ประวัติการทำรายการแอดมิท -->
        <v-list-tile v-for="item in Adminitems" :key="item.title" :to="item.path" active-class="sidemenu"
          v-if="role == 'admin'">
          <v-list-tile-action>
            <v-icon style="color: white;">{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title style="font-size: 15px;  color: white">{{
              item.title
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <!-- Acconut Management -->
        <v-list-group v-if="role == 'admin'" no-action value="true" v-model="drawerAcconut">
          <template v-slot:activator>
            <v-list-tile-action>
              <v-icon style="padding: 0 0 0 16px; color: white">mdi-account-multiple</v-icon>
            </v-list-tile-action>
            <v-list-tile style="padding: 0px">
              <v-list-tile-title style="font-size: 15px;  color: white">การจัดการบัญชีผู้ใช้งาน</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="item in management" :key="item.title" :to="item.path" active-class="sidemenu"
            style="margin-left: -30px;">
            <v-list-tile-action>
              <v-icon style="font-size: 20px;  color: white">
                {{ item.icon }}
              </v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 15px;  color: white">{{
                item.title
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>


        <!-- End Admin -->

        <!-- User -->
        <!-- ประวัติการทำรายการ -->
        <v-list-tile v-for="item in Useritems" :key="item.title" :to="item.path" active-class="sidemenu"
          v-if="role == 'user'">
          <v-list-tile-action>
            <v-icon style=" color: white;">{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title style="font-size: 15px;  color: white">{{
              item.title
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- End User -->
      </v-list>
    </v-navigation-drawer>
    <!-- end mobile-->


    <v-toolbar color="white" dark app class="elevation-1">
      <v-toolbar-title>
        <v-btn icon @click.stop="drawer = !drawer" v-if="mobileView">
          <v-icon color="#54a3bc">mdi-view-headline</v-icon>
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-flex xs2></v-flex>

      <v-toolbar-title v-if="bizname != 'undefined' && !mobileView && role == 'user' || role === 'admin'" style="
          color: black;
          font-weight: normal;
          font-size: 16px;
          margin-right: 7px;
        ">{{ bizname }}&nbsp;</v-toolbar-title>
      <!-- <v-divider
        v-if="!mobileView && role == 'User' && bizname != 'undefined'"
        vertical
        inset
        swidth="100px;"
        color="grey"
      >
      </v-divider> -->


      <!-- ชื่อแถบด้านบนweb -->
      <v-toolbar-title v-if="!mobileView && name !== 'null null'"
        style="color: black; font-size: 16px; margin-right: 7px">Welcome, {{ name }}
      </v-toolbar-title>


      <!-- <v-toolbar-title v-if="!mobileView && name == 'null null'"
        style="color: black; font-size: 16px; margin-right: 7px">Welcome2</v-toolbar-title> -->


      <!-- ชื่อแถบด้านบนmobile -->
      <v-toolbar-title v-if="mobileView && name !== 'null null'"
        style="color: black; font-size: 15px; margin-right: 7px">Welcome, {{ name }}
      </v-toolbar-title>
      <!-- <v-btn @click.stop="dialog = true" flat style="color:#239026;"><v-icon medium style="color:#239026; margin-right:5px;">mdi-alert-circle</v-icon>Report Problem</v-btn> -->
      <v-icon medium @click="logout" style="color: #54a3bc; margin-right: 10px">mdi-logout-variant</v-icon>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
    <v-dialog v-model="dialog" max-width="500" height="auto">
      <v-card style="border-radius: 20px">
        <v-card-title class="headline"><v-icon style="margin-right: 10px">mdi-bullhorn-outline</v-icon>Report
          Problem</v-card-title>
        <v-card-text>
          <v-flex xs12 v-model="valid">
            <!-- <v-text-field
              :rules="[() => !!email || 'This field is required']"
              label="E-mail"
              v-model="email"
              prepend-icon="email"
              required
            ></v-text-field> -->
            <v-text-field :rules="[() => !!topic || 'This field is required']" ref="topic" label="Topic" v-model="topic"
              prepend-icon="mdi-alert-octagram" required></v-text-field>
            <v-textarea v-model="details" ref="details" :rules="[() => !!details || 'This field is required']"
              label="Details" counter prepend-icon="mdi-message-draw" maxlength="240"></v-textarea>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialog = false" v-if="dialog" style="border-radius: 10px" small>
            Close
          </v-btn>

          <v-btn color="green white--text" text :disabled="!valid" @click="reportProblem" style="border-radius: 10px"
            small>
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogloader" persistent content-class="elevation-0">
      <v-layout class="justify-center">
        <v-card color="transparent" class="elevation-0">
          <self-building-square-spinner :animation-duration="2000" :size="70" color="white" />
        </v-card>
      </v-layout>
    </v-dialog>
  </v-app>
</template>

<script>
import { sync } from "vuex-pathify";
import { SelfBuildingSquareSpinner } from "epic-spinners";
export default {
  components: {
    SelfBuildingSquareSpinner,
  },
  data() {
    return {
      role: "",
      account_id: "",
      mobileView: false,
      dialogloader: false,
      updateDate: "",
      dialogtimeout: false,
      drawerUpload: false,
      drawerinv: false,
      drawerTransaction: false,
      tout: "",
      valid: true,
      name: this.$cookies.get("getname"),
      details: "",
      topic: "",
      email: "",
      getname: "",
      custName: "",
      firstname: this.$cookies.get("firstname"),
      bizname: this.$cookies.get("bizname"),
      drawer: false,
      mini: false,
      dialog: false,
      showNav: true,
      direction: "top",
      fab: false,
      fling: false,
      hover: true,
      transition: "slide-y-transition",
      images: {
        logo: require("../assets/inet-logo.png"),
      },
      mainitems: [

      ],
      Useritems: [
        {
          title: "สร้างรายการ",
          icon: "mdi-clipboard-text-outline",
          path: "/createPayment",
        },
        {
          title: "ประวัติการทำรายการ",
          icon: "mdi-history",
          path: "/historyPayment",
        },
      ],
      Adminitems: [
        // { title: 'Transactions', icon: 'mdi-file-export', path: '/transaction' },
        {
          title: "สร้างรายการ",
          icon: "mdi-clipboard-text-outline",
          path: "/admin/createPayment",
        },
        {
          title: "ประวัติการทำรายการ",
          icon: "mdi-history",
          path: "/admin/historyPaymentAdmin",
        },
        {
          title: "การจัดการร้านค้า",
          icon: "mdi-store",
          path: "/admin/manageStore",
        },
      ],
      management: [
        {
          title: "แอดมิน",
          icon: "mdi-account",
          path: "/admin/management/admin",
        },
        {
          title: "ผู้ใช้งานทั่วไป",
          icon: "mdi-account",
          path: "/admin/management/user",
        },
      ],
      TaxidSearch: "",
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/");
    }
  },
  methods: {
    async checkField() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) this.formHasErrors = true;
        this.dialogloader = false;
        this.$refs[f].validate(true);
      });
    },
    // submit () {
    //   this.formHasErrors = false
    //   Object.keys(this.form).forEach(f => {
    //     if (!this.form[f]) this.formHasErrors = true
    //     this.$refs[f].validate(true)
    //   })
    // },
    handleView() {
      this.mobileView = window.innerWidth <= 990;
      this.$cookies.set("screenView", this.mobileView);
    },
    sessionTimeout() {
      if (this.isIdle == true) {
        this.$session.destroy();
        this.dialogtimeout = true;
      }
    },
    alertReport() {
      this.$alert("Feedback summitted", "Success", "success");
      this.clearForm();
    },
    clearForm() {
      Object.keys(this.form).forEach((f) => {
        this.$refs[f].reset();
      });
    },
    async searchCustName() {
      try {
        var { data } = await this.axios.get(
          `${process.env.VUE_APP_APIHOST}/customer_name/` +
          encodeURI(this.TaxidSearch),
          {
            headers: {
              Authorization: this.$cookies.get("token"),
            },
          }
        );
        if (data.status === "Invalid TaxID") {
          this.tokenHashTaxid = null;
          this.TaxidSearch = null;
          alert("ไม่พบ Tax ID นี้ในฐานข้อมูล");
        } else {
          this.TaxidSearch = data.customerName;
          this.tokenHashTaxid = data.token;
          this.$cookies.set("token", this.tokenHashTaxid);
        }
      } catch (error) {
        console.log(error.message);
      }
      // this.tokenHashTaxid = this.custName
    },
    async reportProblem() {
      this.dialogloader = true;
      await this.checkField();
      if (this.formHasErrors == false) {
        try {
          let { data: info } = await this.axios.post(
            // 'https://demos1.serviceone.co.th:1301/API/TierZeroStructureAPI.aspx?Channel=2&PermissionKey=b6ba7f5822eb447c819e3681385097&Email=TDCP&Subject=' + this.topic + '&Detail=' + this.detail + '&Product=SW00001'
            process.env.VUE_APP_APIHOST + "/report_problem",
            {
              subject:
                "TDCP (" +
                this.$cookies.get("getTHname") +
                ") : " +
                this.topic +
                " [JV-Platform]",
              detail: this.details,
              username: this.$cookies.get("username"),
            },
            { headers: { Authorization: this.$cookies.get("token") } }
          );
          // console.log('/report_problem: ', info)
          this.alertReport();
          this.dialog = false;
          this.dialogloader = false;
        } catch (error) {
          // alert(error.message)
          console.log(error.message);
          alert("Something went wrong.Please try again.");
        }
      }
    },
    async getupdatetime() {
      try {
        var { data: updateDate } = await this.axios.get(
          `${process.env.VUE_APP_APIHOST}/update_data`
        );
        this.updateDate = updateDate;
      } catch (error) {
        console.log(error);
      }
    },
    async getdiscountrate() {
      try {
        var { data } = await this.axios.post(
          process.env.VUE_APP_APIHOST + "/chk_cust",
          {
            hash_tax_id: this.$cookies.get("taxIDhash"),
          }
        );
        this.$cookies.set("discountPre_amount", data.discount_amount);
        this.$cookies.set("discountPost_amount", data.postpaid_discount_amount);
        this.$cookies.set("quotaofdiscount", data.usage_quota);
      } catch (error) {
        console.log(error);
      }
    },
    logout() {
      this.$session.destroy();
      this.$cookies.keys().forEach((key) => {
        this.$cookies.remove(key);
      });
      this.$router.push("/");

      // if (this.role === "User") {
      //   this.$router.push("/");
      // } else {
      //   this.$router.push("/");
      // }
    },
  },
  computed: {
    tokenHashTaxid: sync("tokenHashTaxid"),
    // account_id () {
    //   return this.$cookies.get('account_id')
    // },
    username() {
      return this.$cookies.get("username");
    },
    isIdle() {
      this.tout = this.$store.state.idleVue.isIdle;
      return this.tout;
    },
    form() {
      return {
        topic: this.topic,
        details: this.details,
      };
    },
  },
  created() {
    // this.getupdatetime();
    this.handleView();
    // this.getdiscountrate();
    this.role = this.$cookies.get("role");
    console.log("Initial role:", this.role); // ตรวจสอบค่าเริ่มต้นของ role

    this.account_id = this.$cookies.get("account_id");
    window.addEventListener("resize", this.handleView);
  },
  watch: {
    tout() {
      this.sessionTimeout();
    },
    dialog() {
      this.clearForm();
    },
  },
};
</script>

<style>
.sidemenu {
  color: white;
  background-color: #0a487e !important;
  background: #0a487e !important;
}

.transparent :hover {
  cursor: pointer;
}

.v-speed-dial {
  position: absolute;
  font-size: 20px;
}

.v-btn--floating {
  position: relative;
}

.btm {
  padding-left: 32%;
  padding-bottom: 15px;
  position: absolute;
  bottom: 0px;
  font-size: 13px;
}

.logo {
  min-width: 60px;
  margin-left: 20px;
}
</style>
